import { UITexts } from '../../types/ui';

export const uiTexts: UITexts = {
  language: {
    name: "Polish",
    nativeName: "Polski",
    code: "pl",
    flag: "🇵🇱"
  },

  common: {
    loading: "Chwileczkę...",
    error: "Ups, coś poszło nie tak",
    retry: "Spróbuj jeszcze raz",
    back: "Wróć",
    next: "Dalej",
    previous: "Poprzednie",
    finish: "Koniec",
    start: "Zaczynamy!",
    restart: "Od nowa",
    continue: "Kontynuuj",
    cancel: "Anuluj",
    close: "Zamknij",
    ok: "Okej",
    yes: "Tak",
    no: "Nie",
    save: "Zapisz",
    share: "Podziel się",
    copy: "Skopiuj",
    copied: "Skopiowane!",
    minutes: "minut",
    seconds: "sekund",
    question: "pytanie",
    questions: "pytań",
    answer: "odpowiedź",
    answers: "odpowiedzi",
    correct: "Dobrze",
    incorrect: "Źle",
    score: "Wynik",
    time: "Czas",
    difficulty: {
      easy: "Łatwe",
      medium: "Średnie",
      hard: "Trudne",
      // ISTQB Knowledge levels
      k1: "K1",
      k2: "K2",
      k3: "K3",
      k4: "K4"
    }
  },

  demo: {
    title: "AI Tester",
    subtitle: "Wersja demo",
    description: "Czy jesteś gotowy na pensję testera AI? Sprawdź w 15 minut",
    startButton: "Sprawdź swój poziom",
    badge: "DARMOWA WERSJA DEMO",
    features: {
      title: "Co otrzymasz w pełnej wersji",
      items: [
        "300+ pytań eksperckich",
        "11 pełnych rozdziałów programu",
        "40-minutowa symulacja egzaminu",
        "Szczegółowe wyjaśnienia odpowiedzi",
        "Analiza wyników i punktacja",
        "Wielokrotne sesje ćwiczeń",
        "Natychmiastowy i dożywotni dostęp",
        "Format przyjazny dla urządzeń mobilnych",
        "Bonus: Wczesny dostęp do zaawansowanego kursu testowania AI"
      ],
      smartQuestions: {
        title: "Sprytne pytania",
        description: "Prawdziwe scenariusze z praktyki testowania AI"
      },
      instantFeedback: {
        title: "Natychmiastowa odpowiedź",
        description: "Spersonalizowane wyjaśnienia od praktyka z 10+ letnim doświadczeniem"
      },
      previewPower: {
        title: "Symulacja prawdziwej certyfikacji",
        description: "Poczuj, jak to jest przygotowywać się do prawdziwej certyfikacji"
      }
    },
    comparison: {
      demo: {
        title: "DARMOWE DEMO",
        features: [
          "12 wybranych pytań",
          "2 główne tematy",
          "15 minut",
          "Wynik od razu"
        ]
      },
      full: {
        title: "PEŁNA WERSJA",
        features: [
          "300+ pytań eksperckich",
          "Wszystkie 11 rozdziałów",
          "40 minut jak na prawdziwym egzaminie",
          "Szczegółowa analiza",
          "Śledzenie postępów"
        ],
        button: "Pełny dostęp"
      }
    },
    community: "Dołącz do społeczności AI profesjonalistów odkrywających sekrety testowania sztucznej inteligencji",
    trustIndicators: "Oparte na oficjalnych materiałach ISTQB",
    perfectFor: {
      title: "Idealne dla",
      items: [
        "Inżynierów QA przechodzących na testowanie AI",
        "Testerów oprogramowania rozszerzających umiejętności",
        "Specjalistów IT dążących do certyfikacji ISTQB",
        "Każdego przygotowującego się do rozmów o testowaniu AI",
        "Zespołów rozwijających umiejętności w zakresie jakości AI",
        "Profesjonalistów IT rozwijających karierę"
      ]
    }
  },

  // Access Page
  access: {
    title: "Wejście do pełnej wersji",
    subtitle: "Wpisz kod dostępu",
    description: "Uzyskaj nieograniczony dostęp do 300+ eksperckich pytań z testowania AI i kompleksowego przygotowania do egzaminu.",
    form: {
      title: "Wpisz kod dostępu",
      placeholder: "Twój kod dostępu...",
      button: "Otwórz pełną wersję",
      submitting: "Sprawdzam..."
    },
    errors: {
      invalid: "Hmm, kod się nie zgadza. Sprawdź i spróbuj ponownie.",
      empty: "Proszę wpisać kod dostępu.",
      generic: "Coś się popsuło. Spróbuj ponownie."
    },
    success: {
      title: "Witamy! 🎉",
      description: "Masz już nieograniczony dostęp do pełnej wersji ISTQB AI Tester!",
      validDays: "Twój dostęp jest nieograniczony i trwały",
      continueButton: "Do pełnej wersji"
    },
    purchase: {
      title: "Nie masz kodu dostępu?",
      subtitle: "Uzyskaj dostęp już teraz",
      description: "Rozpocznij przygotowanie do certyfikacji z 300+ pytaniami, spersonalizowanymi wyjaśnieniami i pełnym pokryciem programu.",
      features: [
        "300+ eksperckich pytań",
        "Wszystkie 11 rozdziałów programu",
        "Spersonalizowane wyjaśnienia od praktyka z 10+ letnim doświadczeniem",
        "Analiza wyników",
        "Działa na telefonie",
        "Dożywotni dostęp + wszystkie aktualizacje za darmo"
      ],
      button: "Rozpocznij przygotowanie do certyfikacji",
      note: "Pobieranie natychmiast po zakupie"
    },
    security: {
      note: "Kody dostępu są bezpiecznie szyfrowane i chronione",
      expiry: "Nieograniczony dostęp"
    }
  },

  full: {
    title: "Edukacja AI Tester",
    subtitle: "AI Tester Quiz",
    description: "Opanuj wszystkie 11 rozdziałów programu ISTQB AI Testing",
    features: [
      "300+ eksperckich pytań",
      "Wszystkie 11 rozdziałów",
      "40 minut jak na prawdziwym egzaminie"
    ],
    welcome: {
      keyFeatures: {
        title: "Główne funkcje",
        expertQuestions: {
          title: "300+ pytań",
          features: [
            "Cały program w komplecie",
            "Jak na prawdziwym egzaminie",
            "Różne poziomy trudności"
          ]
        },
        adaptiveSystem: {
          title: "Inteligentny system",
          features: [
            "Dostosowuje się do ciebie",
            "Wybiera odpowiednie pytania",
            "Śledzi twoje postępy"
          ]
        },
        detailedAnalytics: {
          title: "Szczegółowa analityka",
          features: [
            "Analiza Twoich wyników",
            "Znajduje słabe punkty",
            "Podpowiada, co studiować"
          ]
        }
      },
      whatMakesDifferent: {
        title: "Dlaczego profesjonaliści wybierają nas",
        expertCreated: {
          title: "Stworzone przez ekspertów",
          description: "Pytania tworzyli praktycy testowania AI, którzy znają się na teorii i praktyce"
        },
        completeCoverage: {
          title: "Pełne pokrycie",
          description: "Wszystkie 11 rozdziałów programu ISTQB AI Tester v1.0 rozłożone na czynniki pierwsze"
        },
        realScenarios: {
          title: "Prawdziwe sytuacje",
          description: "Praktyczne przypadki, z którymi na pewno się spotkasz w pracy testera AI"
        },
        trackProgress: {
          title: "Śledzenie postępów",
          description: "Szczegółowa analityka pokaże Twoje mocne i słabe strony"
        }
      },
      perfectFor: {
        title: "Idealne dla",
        items: [
          "Inżynierów QA chcących przejść na testowanie AI",
          "Testerów poszerzających swój arsenał umiejętności",
          "Specjalistów IT celujących w certyfikat ISTQB",
          "Wszystkich przygotowujących się do rozmów o testowanie AI",
          "Zespołów podnoszczych wiedzę w dziedzinie AI",
          "Profesjonalistów budujących karierę w IT"
        ]
      },
      startButton: "Rozpocznij drogę do certyfikacji",
      trustIndicators: [
        "Sprawdzone przez tysiące kandydatów na całym świecie"
      ]
    }
  },

  quiz: {
    header: {
      title: "AI Tester Quiz",
      timeLeft: "Pozostało czasu",
      progress: "Postęp",
      streak: "Seria"
    },
    navigation: {
      previous: "Wstecz",
      next: "Dalej",
      finish: "Zakończ",
      questionOverview: "Wszystkie pytania",
      swipeHint: "👈 Przesuwaj palcem w lewo/prawo 👉"
    },
    status: {
      answered: "Odpowiedziane",
      notAnswered: "Pominięte",
      current: "Teraz tutaj"
    }
  },

  results: {
    title: "PRÓBA ZAKOŃCZONA",
    congratulations: "Świetnie!",
    percentage: "% zdobyte",
    complete: "QUIZ UKOŃCZONY",
    status: {
      passed: "Result",
      failed: "Result",
      retry: "PONOWNIE",
      pass: "Pass",
      study: "Not Pass"
    },
    performance: {
      genius: "Geniusz testowania AI",
      expert: "Ekspert testowania AI",
      pro: "Profesjonalista testowania AI",
      learner: "Uczący się testowania AI",
      beginner: "Początkujący w testowaniu AI",
      // Full quiz performance levels
      master: "Mistrz testowania AI",
      professional: "Zawodowiec testowania AI",
      candidate: "Kandydat na testera AI",
      // Perfect score level
      perfectMaster: "🎊 ABSOLUTNY MISTRZ 🎊"
    },
    statistics: {
      correct: "Poprawnie",
      total: "Wszystkich Pytań",
      bestStreak: "Najlepsza seria",
      timeSpent: "Spędzonego czasu",
      questions: "Pytań",
      status: "Status"
    },
    actions: {
      showReview: "Zobacz omówienie",
      hideReview: "Ukryj omówienie",
      tryAgain: "Spróbuj demo ponownie",
      tryAgainNew: "Spróbuj nowych pytań",
      shareResults: "Pochwal się wynikiem!",
      shareLinkedIn: "Udostępnij na LinkedIn"
    },
    sharing: {
      title: "Pochwal się wynikiem! 🎉",
      description: "Pokaż kolegom swoją wiedzę o testowaniu AI!",
      hashtags: ["ISTQB", "AITesting", "Certification", "TechSkills", "SoftwareQuality"],
      messages: {
        success: "🎉 Gotowe! LinkedIn otwarty, wynik skopiowany!",
        clipboard: "🎉 Wynik skopiowany do schowka!",
        manual: "Skopiuj ten tekst do publikacji na LinkedIn:"
      },
      // Perfect score sharing
      perfectScore: {
        title: "🎊 IDEALNY WYNIK! 🎊",
        description: "W poście jest sekretny hashtag na 30% zniżki!",
        hashtag: "#ainastasiaquizwinner",
        discountOffer: "30% zniżka na pełny kurs!",
        championText: "Jesteś teraz oficjalnym mistrzem testowania AI!",
        hiddenModeUnlocked: "🎉 WOW! UKRYTY TRYB ZOSTAŁ ODBLOKOWANY! 🎉",
        hiddenModeTitle: "UKRYTY TRYB AKTYWOWANY!",
        russianCongratulations: "🎉 WOW! UKRYTY TRYB ZOSTAŁ ODBLOKOWANY! 🎉",
        perfectScoreMessage: "Wszystkie 40 pytań zostały odpowiedziane poprawnie i odblokowany został sekretny tryb!",
        championOfferTitle: "🎁 SPECJALNA OFERTA DLA MISTRZA:",
        specialOffer: "SUPER OFERTA: Udostępnij ten post i napisz do mnie w mediach społecznościowych z linkiem do swojego postu — otrzymaj 30% zniżki na pełny kurs!",
        contactInstructions: "Opublikuj post na LinkedIn z hashtagiem #ainastasiaquizwinner i napisz do mnie w mediach społecznościowych z linkiem do postu — otrzymaj 30% zniżki na główny kurs!",
        linkedinButtonHint: "💡 W przycisku 'Udostępnij na LinkedIn' już jest gotowy tekst z sekretnym hashtagiem"
      }
    },
    upgrade: {
      title: "Gotowy na pełną wersję?",
      description: "Sprawdź, czy jesteś gotowy na podwyżkę o 30%",
      features: [
        "300+ eksperckich pytań",
        "Wszystkie 11 rozdziałów",
        "trening z unikalnymi pytaniami"
      ],
      button: "Chcę pełną wersję"
    },
    course: {
      title: "Kurs teorii testowania AI",
      subtitle: "📚 PODCIĄGNIJ UMIEJĘTNOŚCI",
      description: "Chcesz się zagłębić? Dołącz do naszego kompleksowego kursu teoretycznego przygotowującego do ISTQB AI Tester.",
      features: [],
      button: "Zgarnij zniżkę",
      // Full quiz course promotion
      fullCourse: {
        nextLevel: "🎓 CZEKA CIĘ NASTĘPNY POZIOM 🎓",
        masterTitle: "Kurs teorii testowania AI",
        masterDescription: "Podciągnij swoją wiedzę o testowaniu AI na profesjonalny poziom dzięki naszemu kompleksowemu kursowi teoretycznemu. Dowiedz się nie tylko CO testować, ale JAK testować systemy AI jak prawdziwy zawodowiec!",
        bonusTitle: "🎁 BONUS DLA UCZESTNIKÓW QUIZU 🎁",
        bonusDescription: "15% ZNIŻKA + ekskluzywne materiały",
        claimButton: "🔥 ZGARNIJ BONUS TERAZ 🔥"
      }
    },
    feedback: {
      title: "Masz pomysły na ulepszenie produktu?",
      button: "Zostaw opinię"
    },
    social: {
      title: "Śledź AI.Nastasia! 🚀",
      description: "Dołącz do ekipy",
      platforms: {
        instagram: "Instagram",
        tiktok: "TikTok",
        linkedin: "LinkedIn",
        telegram: "Telegram"
      }
    }
  },

  review: {
    title: "Omówienie odpowiedzi",
    yourAnswer: "Twoja odpowiedź:",
    correctAnswer: "Poprawna odpowiedź:",
    explanation: "Wyjaśnienie:",
    notAnswered: "Pominięte"
  },

  languageSelector: {
    title: "Wybierz język",
    current: "Aktualnie wybrane",
    available: "Dostępne języki",
    select: "Wybierz"
  },

  mobile: {
    pullToRefresh: "↓ Pociągnij w dół aby odświeżyć ↓",
    swipeInstructions: "👈 Przesuwaj palcem w lewo/prawo 👉",
    tapToSelect: "Dotknij aby wybrać odpowiedź",
    doubleTapToConfirm: "Podwójne dotknięcie do potwierdzenia"
  },

  a11y: {
    languageSelector: "Wybór języka",
    questionProgress: "Pytanie {current} z {total}",
    optionSelected: "Wybrano opcję {option}",
    timerWarning: "Czas się kończy",
    resultsSummary: "Quiz ukończony z wynikiem {score}%"
  }
};